import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';
import {TableBookingRequestsComponent} from "../table-booking-requests/table-booking-requests.component";

@Component({
    standalone: true,
    selector: 'card-booking-requests',
    templateUrl: './card-booking-requests.component.html',
    imports: [CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule, TableBookingRequestsComponent]
})
export class CardBookingRequestsComponent implements OnInit, OnDestroy {

    private config: Config = inject(Config);
    private angularHelperService: AngularHelperService = inject(AngularHelperService);
    private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);

    @Input() requests: any[] | undefined;

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        this.vm.pageSize = this.vm.pageSize || 10;
        this.vm.currentPage = 0;
    }

    ngOnDestroy() {
        this.handleBookingsUpdateDestroy();
    }

    handleBookingsUpdateDestroy() {
        if (this.vm.timerInterval) {
            this.angularHelperService.cancelInterval(this.vm.timerInterval);
        }
    }
}
